/**
 * API minima expuesta por el preload de Electron en `window.aibiDesktop`.
 * Solo existe cuando la web se ejecuta dentro de la aplicacion de escritorio.
 */
export interface DesktopBridge {
  readonly isDesktop: true;
  readonly platform: string;
  readonly versions: {
    readonly electron: string;
    readonly chrome: string;
    readonly node: string;
  };
}

export const DESKTOP_BRIDGE_KEY = 'aibiDesktop';
